import { TextField, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Paper from "@material-ui/core/Paper";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import jwt from "jsonwebtoken";
import * as _ from "lodash";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { Dispatch, StoreState } from "../store";
import { RoleType, RoleTypeLabel } from "../types/index";
import IUserRequestType from "../types/UserRequestType";
import Container from "./Container";

function mapStateToProps({ users, auth: { token } }: StoreState) {
  return {
    token,
    users,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    createUser: (user: IUserRequestType) => dispatch.users.createUser(user),
    deleteUser: (user: IUserRequestType) => dispatch.users.deleteUser(user),
    fetchUserData: () => dispatch.users.fetchUsers(null),
    updateUser: (user: IUserRequestType) => dispatch.users.updateUser(user),
  };
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

interface State {
  currId: number;
  error: string;
  currRole: string;
  isPasswordModalOpen: boolean;
  isDeleteModalOpen: boolean;
  isDeleteAdminModalOpen: boolean;
  isChangeLastAdminModalOpen: boolean;
  isCreateModalOpen: boolean;
  isRoleModalOpen: boolean;
  newPassword: string;
  username: string;
  name: string;
  password: string;
  passwordRepeat: string;
  newPasswordRepeat: string;
  role: RoleType;
}

class UserManagement extends React.Component<
  Props & StyledComponentProps & RouteComponentProps
> {
  public state: State = {
    currId: -1,
    currRole: "",
    error: "",
    isChangeLastAdminModalOpen: false,
    isCreateModalOpen: false,
    isDeleteAdminModalOpen: false,
    isDeleteModalOpen: false,
    isPasswordModalOpen: false,
    isRoleModalOpen: false,
    name: "",
    newPassword: "",
    newPasswordRepeat: "",
    password: "",
    passwordRepeat: "",
    role: RoleType.EMPTY,
    username: "",
  };

  public async componentDidMount() {
    this.props.fetchUserData();
  }

  public render() {
    const { classes } = this.props;
    return (
      <Container>
        <Paper className={classes && classes.paper}>
          <Typography variant="h5">Benutzerverwaltung</Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Benutzername</TableCell>
                <TableCell>Passwort</TableCell>
                <TableCell>Benutzer löschen</TableCell>
                <TableCell>Rolle</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.users.map((item, index) => (
                <TableRow key={index}>
                  <TableCell align="left">{item.id}</TableCell>
                  <TableCell align="left">{item.name}</TableCell>
                  <TableCell align="left">{item.username}</TableCell>
                  <TableCell align="left">
                    <Button
                      className={classes && classes.changePwButton}
                      variant="outlined"
                      onClick={() =>
                        this.setState({
                          currId: item.id,
                          isPasswordModalOpen: true,
                        })
                      }
                      color="secondary"
                    >
                      Passwort ändern
                    </Button>
                  </TableCell>
                  <TableCell align="left">
                    <Button
                      className={classes && classes.deleteButton}
                      variant="outlined"
                      onClick={() =>
                        this.setState({
                          currId: item.id,
                          isDeleteModalOpen: true,
                        })
                      }
                    >
                      Löschen
                    </Button>
                  </TableCell>
                  <TableCell align="left">
                    {item.role === RoleType.ADMIN
                      ? RoleTypeLabel[RoleType.ADMIN]
                      : RoleTypeLabel[RoleType.USER]}
                    <br />
                    <Button
                      variant="outlined"
                      onClick={() =>
                        this.setState({
                          currId: item.id,
                          currRole: item.role,
                          isRoleModalOpen: true,
                        })
                      }
                    >
                      Rolle verwalten
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Dialog
            open={this.state.isPasswordModalOpen}
            onClose={() => this.setState({ isPasswordModalOpen: false })}
            fullWidth={true}
            maxWidth="xs"
            scroll="body"
          >
            <Paper className={classes && classes.paper}>
              <Typography variant="h5">Passwort ändern</Typography>
              <form
                id="deleteForm"
                method="post"
                autoComplete="new-password"
                className={classes && classes.registerForm}
              >
                <input
                  className={classes && classes.fakeInputStyle}
                  type="password"
                  name="fake-password"
                  autoComplete="new-password"
                  tabIndex={-1}
                />
                <TextField
                  margin="normal"
                  type="password"
                  id="newPassword"
                  label="Neues Passwort"
                  onChange={this.handleInputChange}
                  value={this.state.newPassword}
                  fullWidth={true}
                  helperText={this.getPasswordHelperText()}
                  error={this.state.error === "dissimilarPassword"}
                />
                <TextField
                  margin="normal"
                  type="password"
                  id="newPasswordRepeat"
                  onChange={this.handleInputChange}
                  value={this.state.newPasswordRepeat}
                  label=" Neues Passwort Wiederholen"
                  fullWidth={true}
                  helperText={this.getPasswordHelperText()}
                  error={this.state.error === "dissimilarPassword"}
                />
              </form>
              <br />
              <Button
                className={classes && classes.changePwButton}
                variant="outlined"
                color="secondary"
                onClick={this.handleChangePassword}
              >
                Bestätigen
              </Button>
              <Button
                className={classes && classes.changePwButton}
                variant="outlined"
                onClick={() => this.setState({ isPasswordModalOpen: false })}
                color="secondary"
              >
                Zurück
              </Button>
            </Paper>
          </Dialog>
          <Dialog
            open={this.state.isDeleteModalOpen}
            onClose={() => this.setState({ isDeleteModalOpen: false })}
            fullWidth={true}
            maxWidth="xs"
            scroll="body"
          >
            <Paper className={classes && classes.paper}>
              <Typography variant="h5">
                Möchten Sie diesen Benutzer wirklich löschen?
              </Typography>
              <Button
                className={classes && classes.yesButton}
                variant="outlined"
                color="secondary"
                onClick={this.handleDeleteUser}
              >
                Ja
              </Button>
              <Button
                className={classes && classes.noButton}
                variant="outlined"
                onClick={() => this.setState({ isDeleteModalOpen: false })}
                color="secondary"
              >
                Nein
              </Button>
            </Paper>
          </Dialog>
          <Dialog
            open={this.state.isRoleModalOpen}
            onClose={() => this.setState({ isRoleModalOpen: false })}
            fullWidth={true}
            maxWidth="xs"
            scroll="body"
          >
            <Paper className={classes && classes.paper}>
              <Typography variant="h5">
                Möchten Sie diesem Konto die Rolle {""}
                <Typography variant="h5" style={{ fontStyle: "italic" }}>
                  {this.state.currRole === RoleType.ADMIN
                    ? RoleTypeLabel[RoleType.USER]
                    : RoleTypeLabel[RoleType.ADMIN]}
                </Typography>
                zuweisen?
              </Typography>
              <Button
                className={classes && classes.yesButton}
                variant="outlined"
                color="secondary"
                onClick={this.handlePromoteUser}
              >
                Ja
              </Button>
              <Button
                className={classes && classes.noButton}
                variant="outlined"
                onClick={() => this.setState({ isRoleModalOpen: false })}
                color="secondary"
              >
                Nein
              </Button>
            </Paper>
          </Dialog>
          <Dialog
            open={this.state.isDeleteAdminModalOpen}
            onClose={() => this.setState({ isDeleteAdminModalOpen: false })}
            fullWidth={true}
            maxWidth="xs"
            scroll="body"
          >
            <Paper className={classes && classes.paper}>
              <Typography variant="h5">
                Ein Konto mit der Benutzerrolle Administrator kann nicht
                gelöscht werden
              </Typography>
              <Button
                className={classes && classes.changePwButton}
                variant="outlined"
                color="secondary"
                onClick={() => this.setState({ isDeleteAdminModalOpen: false })}
              >
                OK
              </Button>
            </Paper>
          </Dialog>
          <Dialog
            open={this.state.isChangeLastAdminModalOpen}
            onClose={() => this.setState({ isChangeLastAdminModalOpen: false })}
            fullWidth={true}
            maxWidth="xs"
            scroll="body"
          >
            <Paper className={classes && classes.paper}>
              <Typography variant="h5">
                Sie können diesem Administrator keine andere Rolle zuweisen, da
                es sich derzeit um den einzigen Administrator im System handelt.
              </Typography>
              <Button
                className={classes && classes.changePwButton}
                variant="outlined"
                color="secondary"
                onClick={() =>
                  this.setState({ isChangeLastAdminModalOpen: false })
                }
              >
                OK
              </Button>
            </Paper>
          </Dialog>
          <Dialog
            open={this.state.isCreateModalOpen}
            onClose={() => this.setState({ isCreateModalOpen: false })}
            fullWidth={true}
            maxWidth="lg"
            scroll="body"
          >
            <Paper className={classes && classes.paper}>
              <Typography variant="h5">Neuen Benutzer Anlegen</Typography>
              <form
                id="registerForm"
                method="post"
                autoComplete="new-password"
                className={classes && classes.registerForm}
              >
                <input
                  className={classes && classes.fakeInputStyle}
                  type="password"
                  name="fake-password"
                  autoComplete="new-password"
                  tabIndex={-1}
                />
                <TextField
                  margin="normal"
                  type="text"
                  label="Name"
                  fullWidth={true}
                  onChange={this.handleInputChange}
                  id="name"
                  value={this.state.name}
                  helperText={this.getNameHelperText()}
                  error={this.state.error === "name"}
                />
                <TextField
                  margin="normal"
                  type="text"
                  label="Benutzername"
                  onChange={this.handleInputChange}
                  id="username"
                  value={this.state.username}
                  fullWidth={true}
                  helperText={this.getUsernameHelperText()}
                  error={this.state.error === "username"}
                />
                <TextField
                  margin="normal"
                  type="password"
                  label="Passwort"
                  fullWidth={true}
                  onChange={this.handleInputChange}
                  id="password"
                  value={this.state.password}
                  helperText={this.getPasswordHelperText()}
                  error={
                    this.state.error === "dissimilarPassword" ||
                    this.state.error === "missingPassword"
                  }
                />
                <TextField
                  margin="normal"
                  type="password"
                  label="Passwort Wiederholen"
                  id="passwordRepeat"
                  fullWidth={true}
                  onChange={this.handleInputChange}
                  value={this.state.passwordRepeat}
                  helperText={this.getPasswordHelperText()}
                  error={
                    this.state.error === "dissimilarPassword" ||
                    this.state.error === "missingPassword"
                  }
                />
              </form>
              <Button
                className={classes && classes.yesButton}
                variant="outlined"
                color="secondary"
                onClick={this.handleCreateUser}
              >
                Erstellen
              </Button>
              <Button
                className={classes && classes.changePwButton}
                variant="outlined"
                onClick={() => this.setState({ isCreateModalOpen: false })}
                color="secondary"
              >
                Zurück
              </Button>
            </Paper>
          </Dialog>
          <Button
            className={classes && classes.createButton}
            variant="outlined"
            onClick={() => this.setState({ isCreateModalOpen: true })}
            style={{}}
          >
            Benutzer anlegen
          </Button>
        </Paper>
      </Container>
    );
  }

  private getUsernameHelperText = (): string | undefined => {
    if (this.state.error === "username") {
      return "Dieser Benutzername ist bereits in Verwendung, bitte verwenden Sie einen anderen";
    }

    return undefined;
  };

  private getNameHelperText = (): string | undefined => {
    if (this.state.error === "name") {
      return "Bitte geben Sie einen Namen an";
    }

    return undefined;
  };

  private getPasswordHelperText = (): string | undefined => {
    if (this.state.error === "dissimilarPassword") {
      return "Die eingegebenen Passwörter stimmen nicht überein, bitte kontrollieren Sie Ihre Eingabe";
    } else if (this.state.error === "missingPassword") {
      return "Sie müssen ein Passwort angeben, bitte kontrollieren Sie Ihre Eingabe";
    }

    return undefined;
  };

  private handleCreateUser = () => {
    const user = {
      id: 0,
      name: this.state.name,
      password: this.state.password,
      role: RoleType.USER,
      username: this.state.username,
    };

    if (
      _.find(this.props.users, {
        username: this.state.username,
      })
    ) {
      this.setState({ error: "username" });
    } else if (this.state.password !== this.state.passwordRepeat) {
      this.setState({ error: "dissimilarPassword" });
    } else if (this.state.password === "" || this.state.passwordRepeat === "") {
      this.setState({ error: "missingPassword" });
    } else if (this.state.name === "") {
      this.setState({ error: "name" });
    } else {
      this.setState({ isCreateModalOpen: false });
      this.props.createUser(user);
      this.setState({
        name: "",
        password: "",
        passwordRepeat: "",
        role: RoleType.EMPTY,
        username: "",
      });
    }
  };

  private handleDeleteUser = () => {
    const admin = jwt.decode(String(this.props.token));
    const user = {
      id: this.state.currId,
      name: "",
      password: "",
      role: RoleType.EMPTY,
      username: "",
    };
    // tslint:disable-next-line
    if (user.id === admin!["id"]) {
      this.setState({ isDeleteAdminModalOpen: true });
      this.setState({ isDeleteModalOpen: false });
    } else {
      this.setState({ isDeleteModalOpen: false });
      this.props.deleteUser(user);
    }
  };

  private handleChangePassword = () => {
    const user = {
      id: this.state.currId,
      name: this.state.name,
      password: this.state.newPassword,
      role: this.state.role,
      username: this.state.username,
    };

    if (this.state.newPassword !== this.state.newPasswordRepeat) {
      this.setState({ error: "dissimilarPassword" });
    } else {
      this.setState({ isPasswordModalOpen: false });
      this.props.updateUser(user);
      this.setState({ newPassword: "", newPasswordRepeat: "" });
    }
  };

  private handlePromoteUser = () => {
    this.state.currRole === RoleType.ADMIN
      ? (this.state.role = RoleType.USER)
      : (this.state.role = RoleType.ADMIN);
    let adminCount = 0;
    for (const i of this.props.users) {
      if (i.role === RoleType.ADMIN) {
        adminCount++;
      }
    }
    const user = jwt.decode(String(this.props.token));
    if (
      // tslint:disable-next-line
      user!["role"] === RoleType.ADMIN &&
      adminCount <= 1 &&
      this.state.currRole === RoleType.ADMIN
    ) {
      this.setState({
        isChangeLastAdminModalOpen: true,
        isRoleModalOpen: false,
      });
      return;
    }

    const newUser = {
      id: this.state.currId,
      name: "",
      password: "",
      role: this.state.role,
      username: "",
    };

    this.setState({ isRoleModalOpen: false });
    this.props.updateUser(newUser);
    this.setState({ role: RoleType.EMPTY });
  };

  private handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, id } = event.target;
    this.setState({ [id]: value });
  };
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  changePwButton: {
    margin: "5px",
  },
  createButton: {
    borderColor: "green",
    color: "green",
    margin: "10px 5px 0px 5px",
  },
  deleteButton: {
    borderColor: "red",
    color: "red",
    margin: "5px",
  },
  fakeInputStyle: {
    border: "none",
    float: "left",
    height: "0",
    opacity: 0,
    width: "0",
  },
  noButton: {
    borderColor: "red",
    color: "red",
    margin: "5px",
  },
  paper: {
    padding: theme.spacing(2),
  },
  registerForm: {
    marginTop: theme.spacing(1),
    width: "100%", // Fix IE 11 issue.
  },
  textfield: {
    margin: "10px",
  },
  yesButton: {
    borderColor: "green",
    color: "green",
    margin: "5px",
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(UserManagement)));



// WEBPACK FOOTER //
// ./src/components/UserManagement.tsx